module.exports = __webpack_public_path__ + "img/ic_dorbomplus_logo.ed3514bc.png";